// get a random value that is between min and max
// note that both min and max are inclusive
export default (min, max) => {
  const maxMod = max + 1;
  return Math.floor(Math.random() * (maxMod - min) + min); // The maximum is exclusive and the minimum is inclusive
};
